var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import LocalStorageService from "../../../services/localStorage";
import { hasPermission } from "../../../services/getNavigationPages";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { ACTION_DELETE, ACTION_EDIT, DELETE_TITLE_BENEFIT, DELETE_TITLE_PRIME, PLAN_ALERT_AUTO_CLOSE, PLAN_CATALOG_LIMIT, PLAN_DEFAULT_PAGE, PLAN_REFRESH_DELAY_MS, PREMIUM_EVAL_OPTION_ID, routeProductPlans, TAB_BENEFITS, TAB_PRIMES, TOAST_BENEFIT_CREATED, TOAST_BENEFIT_UPDATED, TOAST_PLAN_CREATED, TOAST_PLAN_UPDATED, TOAST_RECORD_DELETED, } from "../constants/planCreation.constants";
import { buildBenefitsColumns, buildPrimesColumns, } from "../constants/planCreation.columns";
import { EMPTY_BENEFIT_FORM, INITIAL_PLAN_FORM, INITIAL_PRIME_FORM, } from "../constants/planCreation.forms";
import { useDeletePlanBenefit } from "./useDeletePlanBenefit";
import { useGetCoverTypes } from "./useGetCoverTypes";
import { useGetPlan } from "./useGetPlan";
import { useGetPlanPaymentModes } from "./useGetPlanPaymentModes";
import { usePlanBenefits } from "./usePlanBenefits";
import { usePlanCreationErrorHandling } from "./usePlanCreationErrorHandling";
import { useSavePlan } from "./useSavePlan";
var lsLogin = new LocalStorageService("assurehub");
var HIDDEN_TOAST = {
    show: false,
    message: "",
    type: typeAlert.success,
};
export var usePlanCreation = function () {
    var navigate = useNavigate();
    var _a = useParams(), idPlan = _a.idPlan, idProduct = _a.idProduct;
    var clientId = useState(function () { return lsLogin.getUserLoginStored().clientId; })[0];
    var _b = useState(""), planId = _b[0], setPlanId = _b[1];
    var _c = useState(""), currentId = _c[0], setCurrentId = _c[1];
    var _d = useState(""), rowId = _d[0], setRowId = _d[1];
    var _e = useState(TAB_BENEFITS), currentTab = _e[0], setCurrentTab = _e[1];
    var _f = useState(false), isEditPlan = _f[0], setIsEditPlan = _f[1];
    var _g = useState(true), disableBenefits = _g[0], setDisableBenefits = _g[1];
    var _h = useState(true), disablePrimes = _h[0], setDisablePrimes = _h[1];
    var _j = useState(false), editBenefit = _j[0], setEditBenefit = _j[1];
    var _k = useState(false), editPrime = _k[0], setEditPrime = _k[1];
    var _l = useState(false), showBenefits = _l[0], setShowBenefits = _l[1];
    var _m = useState(false), showPrimes = _m[0], setShowPrimes = _m[1];
    var _o = useState(false), openModalConfirmDelete = _o[0], setOpenModalConfirmDelete = _o[1];
    var _p = useState(false), showAlert = _p[0], setShowAlert = _p[1];
    var _q = useState(INITIAL_PLAN_FORM), planData = _q[0], setPlanData = _q[1];
    var _r = useState(EMPTY_BENEFIT_FORM), dataFormBenefits = _r[0], setDataFormBenefits = _r[1];
    var _s = useState(INITIAL_PRIME_FORM), dataFormPrimes = _s[0], setDataFormPrimes = _s[1];
    var _t = useState([]), scenarios = _t[0], setScenarios = _t[1];
    var _u = useState([]), selectedCoverTypes = _u[0], setSelectedCoverTypes = _u[1];
    var _v = useState(HIDDEN_TOAST), seeToast = _v[0], setSeeToast = _v[1];
    var refreshTimeout = useRef(null);
    var coverTypesApi = useGetCoverTypes();
    var paymentModesApi = useGetPlanPaymentModes();
    var planApi = useGetPlan();
    var savePlan = useSavePlan();
    var benefitsApi = usePlanBenefits();
    var deleteBenefitApi = useDeletePlanBenefit();
    var permissions = {
        create: hasPermission("admin-product-plan-create"),
        update: hasPermission("admin-product-plan-edit"),
        delete: hasPermission("admin-product-plan-delete"),
    };
    usePlanCreationErrorHandling({
        errorCoverTypes: coverTypesApi.errorCoverTypes,
        errorPaymentModes: paymentModesApi.errorPaymentModes,
        errorPlan: planApi.errorPlan,
        errorCreatePlan: savePlan.errorCreate,
        errorUpdatePlan: savePlan.errorUpdate,
        errorBenefits: benefitsApi.errorList,
        errorCreateBenefit: benefitsApi.errorCreate,
        errorUpdateBenefit: benefitsApi.errorUpdate,
        errorDeleteBenefit: deleteBenefitApi.error,
        setSeeToast: setSeeToast,
    });
    var loadBenefits = function (id) {
        benefitsApi.fetchBenefits({
            enable: true,
            page: PLAN_DEFAULT_PAGE,
            limit: PLAN_CATALOG_LIMIT,
            planId: id,
        });
    };
    var coverTypeBase = useMemo(function () {
        var _a;
        return ((_a = coverTypesApi.coverTypes) !== null && _a !== void 0 ? _a : []).map(function (item) { return ({
            id: item.id,
            name: item.description,
            value: item.id,
        }); });
    }, [coverTypesApi.coverTypes]);
    var coverageTypeList = useMemo(function () {
        var _a, _b;
        var planCoverTypeIds = ((_b = (_a = planApi.plan) === null || _a === void 0 ? void 0 : _a.coverTypes) !== null && _b !== void 0 ? _b : []).map(function (item) { return item.id; });
        return coverTypeBase.map(function (item) {
            return planCoverTypeIds.includes(item.id)
                ? __assign(__assign({}, item), { active: true }) : item;
        });
    }, [coverTypeBase, planApi.plan]);
    var paymentModeList = useMemo(function () {
        var _a;
        return ((_a = paymentModesApi.paymentModes) !== null && _a !== void 0 ? _a : []).map(function (item) { return ({
            id: item.id,
            name: item.description,
            value: item.id,
        }); });
    }, [paymentModesApi.paymentModes]);
    var benefitsData = useMemo(function () {
        var _a;
        return ((_a = benefitsApi.benefits) !== null && _a !== void 0 ? _a : []).map(function (item) { return ({
            id: item.id,
            description: item.description,
            value: item.value,
        }); });
    }, [benefitsApi.benefits]);
    useEffect(function () {
        coverTypesApi.fetchCoverTypes({
            enable: true,
            page: PLAN_DEFAULT_PAGE,
            limit: PLAN_CATALOG_LIMIT,
        });
        paymentModesApi.fetchPaymentModes({
            enable: true,
            page: PLAN_DEFAULT_PAGE,
            limit: PLAN_CATALOG_LIMIT,
            clientId: clientId,
        });
        if (idPlan) {
            loadBenefits(idPlan);
        }
        return function () {
            if (refreshTimeout.current)
                clearTimeout(refreshTimeout.current);
        };
    }, []);
    useEffect(function () {
        if (idPlan) {
            setPlanId(idPlan);
            setIsEditPlan(true);
        }
    }, [idPlan, idProduct]);
    useEffect(function () {
        if (coverTypeBase.length > 0 && idPlan) {
            planApi.fetchPlan(idPlan);
        }
    }, [coverTypeBase]);
    useEffect(function () {
        if (!isEditPlan)
            return;
        setDisableBenefits(false);
        setDisablePrimes(false);
    }, [isEditPlan]);
    useEffect(function () {
        var _a, _b;
        var plan = planApi.plan;
        if (!(plan === null || plan === void 0 ? void 0 : plan.id))
            return;
        setPlanId(plan.id);
        setPlanData({ Name: plan.name, Code: plan.code });
        setScenarios(((_a = plan.scenariosPricing) !== null && _a !== void 0 ? _a : []).map(function (item, index) {
            var _a, _b, _c, _d;
            return ({
                id: index,
                minAge: item.minAge,
                maxAge: item.maxAge,
                paymentModeId: (_a = item.paymentMode) === null || _a === void 0 ? void 0 : _a.id,
                premiumEvalTypeId: PREMIUM_EVAL_OPTION_ID,
                price: item.price,
                coverTypeId: (_b = item.coverType) === null || _b === void 0 ? void 0 : _b.id,
                paymentMode: (_c = item.paymentMode) === null || _c === void 0 ? void 0 : _c.description,
                coverType: (_d = item.coverType) === null || _d === void 0 ? void 0 : _d.description,
            });
        }));
        var planCoverTypeIds = ((_b = plan.coverTypes) !== null && _b !== void 0 ? _b : []).map(function (item) { return item.id; });
        setSelectedCoverTypes(coverTypeBase
            .filter(function (item) { return planCoverTypeIds.includes(item.id); })
            .map(function (item) { return (__assign(__assign({}, item), { active: true })); }));
    }, [planApi.plan, coverTypeBase]);
    useEffect(function () {
        var created = savePlan.createdPlan;
        if (!(created === null || created === void 0 ? void 0 : created.id))
            return;
        setPlanId(created.id);
        showToastSuccessMessage(TOAST_PLAN_CREATED, typeAlert.success, setSeeToast);
        refreshTimeout.current = setTimeout(function () {
            setPlanId(created.id);
            planApi.fetchPlan(created.id);
            setIsEditPlan(true);
        }, PLAN_REFRESH_DELAY_MS);
        savePlan.clearCreated();
    }, [savePlan.createdPlan]);
    useEffect(function () {
        var _a;
        if (!((_a = savePlan.updatedPlan) === null || _a === void 0 ? void 0 : _a.id))
            return;
        planApi.fetchPlan(planId);
        showToastSuccessMessage(TOAST_PLAN_UPDATED, typeAlert.success, setSeeToast);
        savePlan.clearUpdated();
    }, [savePlan.updatedPlan]);
    useEffect(function () {
        var _a;
        if (!((_a = benefitsApi.createdBenefit) === null || _a === void 0 ? void 0 : _a.id))
            return;
        loadBenefits(planId);
        showToastSuccessMessage(TOAST_BENEFIT_CREATED, typeAlert.success, setSeeToast);
        benefitsApi.clearCreated();
    }, [benefitsApi.createdBenefit]);
    useEffect(function () {
        var _a;
        if (!((_a = benefitsApi.updatedBenefit) === null || _a === void 0 ? void 0 : _a.id))
            return;
        showToastSuccessMessage(TOAST_BENEFIT_UPDATED, typeAlert.success, setSeeToast);
        loadBenefits(planId);
        benefitsApi.clearUpdated();
    }, [benefitsApi.updatedBenefit]);
    useEffect(function () {
        if (!deleteBenefitApi.benefitDeleted)
            return;
        showToastSuccessMessage(TOAST_RECORD_DELETED, typeAlert.success, setSeeToast);
        loadBenefits(planId);
        deleteBenefitApi.clearDeleted();
    }, [deleteBenefitApi.benefitDeleted]);
    var buildScenarioPayload = function (rows) {
        return rows.map(function (item, index) { return ({
            minAge: Number(item.minAge),
            maxAge: Number(item.maxAge),
            paymentModeId: item.paymentModeId,
            premiumEvalTypeId: item.premiumEvalTypeId,
            price: Number(item.price),
            coverTypeId: item.coverTypeId,
            order: index + 1,
        }); });
    };
    var buildCoverTypesPayload = function () {
        return selectedCoverTypes.map(function (item) { return ({
            coverTypeId: item.id,
            premiumEvalOptionId: PREMIUM_EVAL_OPTION_ID,
        }); });
    };
    var updateScenarios = function (rows) {
        var body = {
            name: planData.Name,
            code: planData.Code,
            projectId: idProduct,
            scenarios: buildScenarioPayload(rows),
            coverTypes: buildCoverTypesPayload(),
        };
        savePlan.updatePlan({ id: planId, body: body });
    };
    var handleSubmitPlan = function (form) {
        var body = {
            name: form.Name,
            code: form.Code,
            projectId: idProduct,
            scenarios: buildScenarioPayload(scenarios),
            coverTypes: buildCoverTypesPayload(),
        };
        if (isEditPlan) {
            savePlan.updatePlan({ id: planId, body: body });
        }
        else {
            savePlan.createPlan(body);
        }
    };
    var onSaveBenefit = function (form) {
        var body = {
            description: form.Name,
            value: form.Value,
            planId: planId,
        };
        if (editBenefit) {
            benefitsApi.updateBenefit({ id: currentId, body: body });
        }
        else {
            benefitsApi.createBenefit(body);
        }
        setShowBenefits(false);
    };
    var onSavePrime = function (form) {
        var row = {
            minAge: Number(form.Age[0]),
            maxAge: Number(form.Age[1]),
            paymentModeId: form.IdType,
            premiumEvalTypeId: PREMIUM_EVAL_OPTION_ID,
            price: parseFloat(form.Prime),
            coverTypeId: form.IdCoverType,
        };
        var rows = __spreadArray([], scenarios, true);
        if (editPrime) {
            rows[form.id] = row;
        }
        else {
            rows.push(row);
        }
        setScenarios(rows);
        updateScenarios(rows);
        setShowPrimes(false);
    };
    var onClickAddBenefits = function () {
        setDataFormBenefits(EMPTY_BENEFIT_FORM);
        setEditBenefit(false);
        setShowBenefits(true);
    };
    var onClickAddPrimes = function () {
        setShowPrimes(true);
        setEditPrime(false);
    };
    var handleAction = function (item, row, type) {
        setCurrentTab(type === "benefits" ? TAB_BENEFITS : TAB_PRIMES);
        setRowId(row.idrow);
        setCurrentId(row.id);
        if (item.id === ACTION_DELETE) {
            setOpenModalConfirmDelete(true);
        }
        if (item.id === ACTION_EDIT && type === "benefits") {
            setEditBenefit(true);
            setShowBenefits(true);
            setDataFormBenefits({ Name: row.description, Value: row.value });
        }
        if (item.id === ACTION_EDIT && type === "primes") {
            setShowPrimes(true);
            setEditPrime(true);
            setDataFormPrimes({
                id: row.id,
                Age: [row.minAge, row.maxAge],
                IdType: row.paymentModeId,
                Prime: row.price,
                IdCoverType: row.coverTypeId,
            });
        }
    };
    var onConfirmDelete = function () {
        setOpenModalConfirmDelete(false);
        if (currentTab === TAB_BENEFITS) {
            deleteBenefitApi.deleteBenefit({
                id: currentId,
                userId: lsLogin.getUserLoginStored().userId,
            });
        }
        if (currentTab === TAB_PRIMES) {
            var rows = scenarios.filter(function (_, index) { return index !== rowId; });
            setScenarios(rows);
            updateScenarios(rows);
        }
    };
    var columnsBenefits = buildBenefitsColumns(function (item, row) {
        return handleAction(item, row, "benefits");
    });
    var columnsPrimes = buildPrimesColumns(function (item, row) {
        return handleAction(item, row, "primes");
    });
    return {
        loading: coverTypesApi.loadingCoverTypes ||
            paymentModesApi.loadingPaymentModes ||
            planApi.loadingPlan ||
            savePlan.loadingCreate ||
            savePlan.loadingUpdate ||
            benefitsApi.loading ||
            deleteBenefitApi.loading,
        seeToast: seeToast,
        closeToast: function () { return setSeeToast(HIDDEN_TOAST); },
        view: {
            permissions: permissions,
            currentTab: currentTab,
            scenarios: scenarios,
            coverageTypeList: coverageTypeList,
            selectedCoverTypes: selectedCoverTypes,
            paymentModeList: paymentModeList,
            planData: planData,
            dataFormBenefits: dataFormBenefits,
            dataFormPrimes: dataFormPrimes,
            benefitsData: benefitsData,
            columnsBenefits: columnsBenefits,
            columnsPrimes: columnsPrimes,
            openModalBenefit: showBenefits,
            openModalPrime: showPrimes,
            onCloseModalBenefit: function () { return setShowBenefits(false); },
            onClosePrimeModal: function () { return setShowPrimes(false); },
            onSaveBenefit: onSaveBenefit,
            onSavePrime: onSavePrime,
            onClickAddBenefits: onClickAddBenefits,
            onClickAddPrimes: onClickAddPrimes,
            onUpdateCoverTypeSelected: setSelectedCoverTypes,
            handleSubmitPlan: handleSubmitPlan,
            showAlert: showAlert,
            setShowAlert: setShowAlert,
            autoClose: PLAN_ALERT_AUTO_CLOSE,
            autoCloseActive: false,
            onClickBack: function () { return navigate(routeProductPlans(idProduct)); },
            disableBenefits: disableBenefits,
            disablePrimes: disablePrimes,
            idPlan: planId,
            isEdit: isEditPlan.toString(),
            activateEditMode: !isEditPlan,
            openModalConfirmDelete: openModalConfirmDelete,
            setOpenModalConfirmDelete: setOpenModalConfirmDelete,
            titleDelete: currentTab === TAB_BENEFITS ? DELETE_TITLE_BENEFIT : DELETE_TITLE_PRIME,
            onConfirmDelete: onConfirmDelete,
        },
    };
};
